// iter159 — Skeleton loader'lar: kart ve grid iskeletleri (yükleme sırasında layout korunur, kullanıcı beklerken boş ekran görmez)
export function ProductCardSkeleton() {
  return (
    <div className="bg-white rounded-2xl border border-zinc-100 overflow-hidden" data-testid="skeleton-card">
      <div className="aspect-[4/5] bg-gradient-to-br from-zinc-100 to-zinc-50 animate-pulse"/>
      <div className="p-4 space-y-2">
        <div className="h-2.5 w-16 bg-zinc-100 rounded animate-pulse"/>
        <div className="h-4 w-full bg-zinc-100 rounded animate-pulse"/>
        <div className="h-4 w-2/3 bg-zinc-100 rounded animate-pulse"/>
        <div className="pt-3 mt-3 border-t border-zinc-100 flex items-end justify-between">
          <div className="space-y-1.5">
            <div className="h-2 w-8 bg-zinc-100 rounded animate-pulse"/>
            <div className="h-5 w-20 bg-zinc-100 rounded animate-pulse"/>
          </div>
          <div className="h-3 w-12 bg-zinc-100 rounded animate-pulse"/>
        </div>
      </div>
    </div>
  );
}

export function ProductGridSkeleton({ count = 12, cols = "grid-cols-2 md:grid-cols-3 lg:grid-cols-4" }) {
  return (
    <div className={`grid ${cols} gap-3 md:gap-4`} data-testid="skeleton-grid">
      {Array.from({ length: count }).map((_, i) => <ProductCardSkeleton key={i}/>)}
    </div>
  );
}

export function CategoryHeroSkeleton() {
  return (
    <section className="max-w-[1400px] mx-auto px-4 sm:px-6 py-10 md:py-14" data-testid="skeleton-hero">
      <div className="grid grid-cols-12 gap-4 md:gap-6">
        <div className="col-span-12 lg:col-span-4 aspect-[4/3] lg:aspect-auto lg:min-h-[380px] rounded-3xl bg-gradient-to-br from-zinc-200 to-zinc-100 animate-pulse"/>
        <div className="col-span-12 lg:col-span-8">
          <ProductGridSkeleton count={4} cols="grid-cols-2 md:grid-cols-3 xl:grid-cols-4"/>
        </div>
      </div>
    </section>
  );
}
